/**
 * @generated SignedSource<<2558ca0ec6ace4525424fa9fc69e7030>>
 * @relayHash 7a931bcd13e6996e8ed7e344416a690a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 45a7eb7f3e688d0b182101c91cfc5cdc5f850c3fb9360eccaf64434a967efc2d

var node = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "containerId"
    },
    v2 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "containerType"
    },
    v3 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentId"
    },
    v4 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentType"
    },
    v5 = [{
      "args": [{
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }, {
        "kind": "Variable",
        "name": "containerId",
        "variableName": "containerId"
      }, {
        "kind": "Variable",
        "name": "containerType",
        "variableName": "containerType"
      }, {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }, {
        "kind": "Variable",
        "name": "contentType",
        "variableName": "contentType"
      }],
      "concreteType": "ReactionsSummaryResponse",
      "kind": "LinkedField",
      "name": "reactionsSummary",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "name": "ari"
      }, {
        "kind": "ScalarField",
        "name": "containerAri"
      }, {
        "concreteType": "ReactionsSummaryForEmoji",
        "kind": "LinkedField",
        "name": "reactionsSummaryForEmoji",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "name": "emojiId"
        }, {
          "kind": "ScalarField",
          "name": "count"
        }, {
          "kind": "ScalarField",
          "name": "reacted"
        }]
      }]
    }];
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/, v3 /*: any*/, v4 /*: any*/],
      "kind": "Fragment",
      "name": "mainReactionsSummaryQuery",
      "selections": v5 /*: any*/,
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v0 /*: any*/, v3 /*: any*/, v4 /*: any*/, v1 /*: any*/, v2 /*: any*/],
      "kind": "Operation",
      "name": "mainReactionsSummaryQuery",
      "selections": v5 /*: any*/
    },
    "params": {
      "id": "45a7eb7f3e688d0b182101c91cfc5cdc5f850c3fb9360eccaf64434a967efc2d",
      "metadata": {},
      "name": "mainReactionsSummaryQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "3c0583af7bfaeb4e6576b658938208c1";
export default node;